export default __webpack_public_path__ + "static/media/VD2.acdf429f.png";